var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.productsPerCategory)?_c('router-view'):_c('MissingMessage',{staticClass:"margins__triple",attrs:{"main-message":_vm.$t('OFFER.OFFER_IS_MISSING'),"secondary-message":_vm.$t('OFFER.GO_BACK_TO_GENERATE')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }